export default __webpack_public_path__ + "static/media/6Y.7ad7c4b5.png";